import { SINOX_TAX_ID } from "@/constants/global";
import type { User } from "@/types/auth.type";
import type { MeResponse } from "./me.dto";

export const dtoToMe = (payload: MeResponse): User => {
  const isRoot = payload.isRoot;
  const isFactory = payload.customer.role === "central_factory";
  const isSupplier = payload.customer.role === "supplier";

  return {
    id: payload.id.toString(),
    nickname: payload.nickname ? payload.nickname : null,
    customerName: payload.customer.name,
    customerId: payload.customer.id.toString(),
    taxId: payload.customer.taxId,
    email: payload.email,
    role: isRoot ? "root" : isFactory ? "factory" : "supplier",
    isAdmin: payload.isAdmin ? payload.isAdmin : false,
    isRoot: payload.isRoot ? payload.isRoot : false,
    isFactory,
    isSupplier,
    uiConfig: {
      ...payload.customer.uiConfig,
      isSinox: payload.customer.taxId === SINOX_TAX_ID,
    },
    permissions: payload.permissions.reduce<Record<string, boolean>>((acc, { name }) => {
      acc[name] = true;
      return acc;
    }, {}),
  };
};
